import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthUtil } from './auth-util';
import { environment } from "../../environments/environment";

@Injectable({providedIn: 'root'})
export class BUGuard  {

    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if(!environment.AZURE_LOGIN_NEEDED) {
            return true
        }
        
        let authUtil = new AuthUtil()
        const access_token = authUtil.getAccessToken()
        const userPermission: string[] = authUtil.getRoleClaim(access_token)
        const message = `You are not allowed to use the module. Ask your admin to add appropriate permission`
        let routePermissionNeeded = route.data.claim
        let matchedRoles = userPermission.filter(claim => routePermissionNeeded.includes(claim))
                
        if(matchedRoles.length > 0) {
            return true
        } else {
            alert(message)
            localStorage.removeItem('lab')
            this.router.navigate(['/'])
            window.location.reload()
            return false
        }

    }

}